import { render, staticRenderFns } from "./ImportarSignatariosMenu.vue?vue&type=template&id=13be421e"
import script from "./ImportarSignatariosMenu.vue?vue&type=script&lang=js"
export * from "./ImportarSignatariosMenu.vue?vue&type=script&lang=js"
import style0 from "./ImportarSignatariosMenu.vue?vue&type=style&index=0&id=13be421e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports